import { PathPoints } from '@features/view/MarkerLine';
import React, { useCallback } from 'react';

export interface CPRGuideLineProps {
  dimensions: { width: number; height: number };
  overlayTranslation: [number, number];
  path: PathPoints[];
  name: string;
  index: number;
}

const CPRGuideLine: React.FC<CPRGuideLineProps> = ({
  dimensions,
  overlayTranslation,
  path,
  name,
  index,
}) => {
  const yAtPathIndex = useCallback(
    (rawIndex: number) => {
      if (path.length === 0) return null;
      let idx = Math.max(0, Math.min(path.length - 1, rawIndex));
      const { x, y } = path[idx];
      return y;
    },
    [path],
  );

  const pad = 6;
  const y = yAtPathIndex(index);
  if (y == null) return null;

  return (
    <g key={`guide`} pointerEvents="none">
      <line
        x1={-overlayTranslation[0]}
        y1={y}
        x2={dimensions.width - overlayTranslation[0]}
        y2={y}
        stroke="red"
        strokeWidth={1.5}
        strokeDasharray="4 3"
      />
      <text
        x={dimensions.width - pad - overlayTranslation[0]}
        y={y - pad}
        fill="red"
        fontSize={12}
        fontWeight={700}
        textAnchor="end"
        alignmentBaseline="baseline"
        style={{
          paintOrder: 'stroke',
          stroke: 'rgba(0,0,0,0.6)',
          strokeWidth: 3,
        }}
      >
        {name}
      </text>
    </g>
  );
};

export default CPRGuideLine;
